import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { baseURL } from "../Constant";
export const TeaserSlice = createSlice({
 name: "teaser",
 initialState: {
  error: false,

  teaserMail: "",
  isTeaserLoaded: false,
 },
 reducers: {
  setTeaserMail: (state, { payload }) => {
   state.teaserMail = payload;
   state.isTeaserLoaded = true;
  },

  setError: (state) => {
   state.error = true;
  },

  setTeaserLoad: (state) => {
   state.isTeaserLoaded = false;
  },
 },
});

// Action creators are generated for each case reducer function
export const { setError, setTeaserMail, setTeaserLoad } = TeaserSlice.actions;

export default TeaserSlice.reducer;

export function handleGenerateTeaser(values) {
 return (dispatch) => {
  console.log("in here dispacth");

  axios
   .post(`${baseURL}/teaser/fetchResponse`, { values })
   .then((response) => {
    // then print response status
    dispatch(setTeaserMail(response.data));
   })
   .catch((err) => {
    // then print response status
    // console.error("fetch fail", err);
   });
 };
}
export function handleTeaserLoading() {
 return (dispatch) => {
  dispatch(setTeaserLoad());
 };
}
